module.exports = __webpack_public_path__ + "img/order-subnav.a812ed9e.svg";